export default "/presentation/resources/sap/ui/webcomponents/main/messagebundle_lv.cb22b4a4f0537065.json"